import { IconExternal } from '@components/icons';
import { Icon, Wrapper } from './LinkExternal.styles';

interface LinkExternalProps {
  classes?: any;
  children: React.ReactNode;
  href: string;
}

export default function LinkExternal({ classes, children, href }: LinkExternalProps) {
  return (
    <Wrapper href={href} target="_blank" rel="noreferrer">
      <span>{children}</span>
      <Icon>
        <IconExternal />
      </Icon>
    </Wrapper>
  );
}
